import React from 'react';

export default function(props: React.PropsWithChildren<{
    show: boolean
}>) {
    return <React.Fragment>{props.show ? props.children : []}</React.Fragment>;
}
